<template>
  <row class="lc-editor-info">
    <divider orientation="left">Сведения о судебном деле</divider>
    <div class="lc-editor-info__row lc-editor-info__row--status">
      <row :gutter="16">
        <i-col span="12">
          <i-select
            placeholder="Статус судебного дела"
            v-model="lawCase.law_status_id"
          >
            <i-option
              v-for="status in lawCaseStatuses"
              :value="status.id"
              :key="status.id"
            >
              {{ status.name }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
    <div class="lc-editor-info__row lc-editor-info__row--participants">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">
            Заявитель
          </span>
          <i-select
            filterable
            placeholder="Выберите компанию"
            v-model="lawCase.applicant_id"
            @on-select="value => onSelect('applicant_id', value)"
          >
            <i-option
              v-for="applicant in applicants"
              :value="applicant.id"
              :key="applicant.id"
              >{{ applicant.name }}</i-option
            >
          </i-select>
        </i-col>
        <i-col span="12">
          <span class="ms-help label">
            Ответчик
          </span>
          <i-select
            filterable
            placeholder="Выберите компанию"
            v-model="lawCase.defendant_id"
            @on-select="value => onSelect('defendant_id', value)"
          >
            <i-option
              v-for="defendant in defendants"
              :value="defendant.id"
              :key="defendant.id"
              >{{ defendant.name }}</i-option
            >
          </i-select>
        </i-col>
      </row>
    </div>
    <row class="lc-editor-info__row lc-editor-info__row--dates">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">
            Начало
          </span>
          <date-picker
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            v-model="lawCase.start_date"
          />
        </i-col>
        <i-col span="12">
          <span class="ms-help label">
            Окончание
          </span>
          <date-picker
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            v-model="lawCase.end_date"
          />
        </i-col>
      </row>
    </row>
    <div class="lc-editor-info__row lc-editor-info__row--additional">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">Суд</span>
          <i-input v-model="lawCase.law_info" placeholder="Информация о суде" />
        </i-col>
        <i-col span="12">
          <span class="ms-help label">Номер судебного дела</span>
          <i-input
            v-model="lawCase.number"
            placeholder="Номер судебного дела"
          />
        </i-col>
      </row>
    </div>
    <div class="lc-editor-info__row lc-editor-info__row--costs">
      <row :gutter="16">
        <i-col span="24">
          <span class="ms-help label">Размер исковых требований</span>
          <input-number
            placeholder="Укажите сумму"
            v-model="lawCase.costs"
            :min="0"
            :formatter="costsFormatter"
            :parser="costsParser"
            size="default"
          />
        </i-col>
      </row>
    </div>
  </row>
</template>

<script>
import { costsFormatter, costsParser } from '@/utils'

export default {
  props: ['law-case', 'companies', 'law-case-statuses'],
  computed: {
    applicants () {
      return this.companies.filter(c => c.id !== this.lawCase.defendant_id)
    },
    defendants () {
      return this.companies.filter(c => c.id !== this.lawCase.applicant_id)
    }
  },
  methods: {
    onSelect (field, value) {
      setTimeout(() => this.$set(this.lawCase, field, value.value), 0)
    },
    costsFormatter,
    costsParser
  }
}
</script>

<style lang="less">
.lc-editor-info {
  &__row {
    width: 100%;

    &--status {
      margin-bottom: 16px;
    }

    &--participants {
      margin-bottom: 8px;
    }

    &--dates {
      margin-bottom: 16px;

      .ivu-date-picker {
        width: 100%;
      }
    }

    &--costs {
      margin-top: 16px;

      .ivu-input-number {
        width: 100%;
      }
    }
  }
}
</style>
